/**
 * Copyright (c) 2022 Strategio Digital s.r.o.
 * @author Jiří Zapletal (https://strategio.digital, jz@strategio.digital)
 */

import { useCompanyStore } from '@/components/store/companyStore'

export const useProformaPrefix = () => {
    const companyStore = useCompanyStore()
    const proformaPrefix = (proforma: boolean): string => {
        if (proforma) {
            return companyStore.current?.proformaPrefix || ''
        }
        return ''
    }

    return {
        proformaPrefix
    }
}